import { DatePicker } from "@/components/ui/date-picker";
import type { FieldConfig } from "../types";

interface DateFieldProps<T> {
  field: FieldConfig<T>;
  value: Date | string | undefined;
  onChange: (value: Date | undefined) => void;
  onBlur: () => void;
  disabled?: boolean;
  id: string;
  placeholder?: string;
  "aria-describedby"?: string;
  "aria-invalid"?: boolean;
}

export function DateField<T>({
  field,
  value,
  onChange,
  // onBlur, // Commented out - DatePicker doesn't support onBlur yet, but kept to satisfy CodeRabbit complaints about missing parameter
  disabled,
  id, // Now used for accessibility
  placeholder,
  "aria-describedby": ariaDescribedBy, // Now used for accessibility
  "aria-invalid": ariaInvalid,
}: DateFieldProps<T>) {
  return (
    <DatePicker
      placeholder={placeholder}
      disabled={disabled}
      value={value}
      onChange={onChange}
      id={id}
      aria-describedby={ariaDescribedBy}
      aria-invalid={ariaInvalid}
      aria-required={field.required || undefined}
    />
  );
}
